export default "https://cdn-web.disco.co/generic-cover-image-c3980a36be06ce0bd30549684945cbbe.png";